import { AddressValidatedAddressJsonldAddressRead } from '@/api/generated';
import RgpdDisclaimer from '@/organisms/RgpdDisclaimer';
import ModalClassicLayout from '../../layout/Classic';
import AddressForm from './AddressForm';
import useAddressCreateModal from './hooks';
import ResultForm from './ResultForm';

const AddressCreateModal = ({
  closeModal,
  title,
  callback,
}: {
  closeModal: () => void;
  title?: string;
  callback?: (v: AddressValidatedAddressJsonldAddressRead) => void;
}) => {
  const { handleValidateAddress, validationResult, handleCreateAddress } = useAddressCreateModal({ callback });

  return (
    <ModalClassicLayout closeModal={closeModal} title={title}>
      {!validationResult || !validationResult.data.isValid ? (
        <AddressForm validateAddress={handleValidateAddress} />
      ) : (
        <ResultForm handleCreateAddress={handleCreateAddress} validationResult={validationResult.data} />
      )}

      <RgpdDisclaimer />
    </ModalClassicLayout>
  );
};

export default AddressCreateModal;
